import { useSyncExternalStore } from 'react'

/**
 * Track a media query, live.
 *
 * `useSyncExternalStore` reads `matchMedia` straight, so the first render
 * already carries the right value — no mount effect, and therefore no flash of
 * the desktop layout before a phone corrects itself. The server snapshot is
 * `false` (desktop-ish), which is also the right default for a build with no
 * window at all.
 */
export function useMedia(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mq = window.matchMedia(query)
      mq.addEventListener('change', onChange)
      return () => mq.removeEventListener('change', onChange)
    },
    () => window.matchMedia(query).matches,
    () => false,
  )
}
